module.exports = __webpack_public_path__ + "img/back-arrow-blue.34fdead4.svg";